export default __webpack_public_path__ + "static/media/wow-72.5b5c3a76.svg";